import { Routes, Route } from "react-router-dom";
import List from "./List";
import Bulk from "./Bulk";
import Form from "./Form";
import View from "./View";
export const MODEL = "sku";
export const BASE_PATH = "/purchases/purchase-orders/goods-receive-notes";
export const TITLE = ["Goods Receive Note", "Goods Receive Notes"];
export default function Entity(props: any) {
  return (
    <Routes>
      <Route path={`/bulk`} element={<Bulk />} />
      <Route path={`/form/:id`} element={<Form />} />
      <Route path={`/:id`} element={<View />} />
      <Route path={`/`} element={<List />} />
    </Routes>
  );
}
